module.exports = __webpack_public_path__ + "static/media/social-1_logo-onedrive.67d23faa.svg";